
import getEnvironment from '../../../env';
import { RequestMutationWrapper } from '../../../models/API/RequestMutationWrapper';
import BaseModel from '../../../models/BaseModels/BaseModel';
import { DnsCreateTXTRequest, DnsCreateTXTResponse } from '../../../models/dns';
import HandleQuery from '../../../redux/EndpointQueryHandler';
import { GetManyPackage } from '../../../redux/GetManyPackage';
import handleResponse from '../../../redux/handleResponse';
import { portalApiSlice } from '../../../redux/portalApiSlice';
import { transformMultipleResponseToRightType, transformSingleResponseToRightType } from '../../../redux/transformResponse';

const baseurl = getEnvironment().REACT_APP_API_BASEURL;

export const dnsApiSlice = portalApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllRecordsByOrgId: builder.query<DnsCreateTXTResponse[], GetManyPackage>({
      query: (pack) => HandleQuery({
        url: `${baseurl}/organisations/${pack.uuid}/dns/records`,
        responseHandler: (res) => handleResponse({ response: res, toastWithResult: false, toastErrorText: "Records could not be fetched" }),
        pagination: pack.pagination
      }),
      transformResponse: (a: DnsCreateTXTResponse[], b, c) => transformMultipleResponseToRightType(DnsCreateTXTResponse, a, b, c),
      providesTags: ['dns-records']
    }),
    getAllRecords: builder.query<DnsCreateTXTResponse[], GetManyPackage>({
      query: (pack) => HandleQuery({
        url: `${baseurl}/dns/records`,
        responseHandler: (res) => handleResponse({ response: res, toastWithResult: false, toastErrorText: "Records could not be fetched" }),
        pagination: pack.pagination
      }),
      transformResponse: (a: DnsCreateTXTResponse[], b, c) => transformMultipleResponseToRightType(DnsCreateTXTResponse, a, b, c),
      providesTags: ['dns-records']
    }),
    addRecord: builder.mutation<DnsCreateTXTResponse, RequestMutationWrapper<DnsCreateTXTRequest>>({
      query: (request) => {
        const { prefix, suffix, ...restData } = request.data as any;

        return HandleQuery({
          url: `${baseurl}/dns/records`,
          responseHandler: (res) => handleResponse({ response: res, toastSuccessText: "Record was created", toastErrorText: "Record could not be created" }),
          method: 'POST',
          body: {
            ...restData,

            prefix: prefix === "" ? undefined : prefix,
            suffix_id: typeof suffix === 'object' ? suffix.uuid : suffix
          },
        })
      },
      transformResponse: (a: DnsCreateTXTResponse, b, c) => transformSingleResponseToRightType(DnsCreateTXTResponse, a, b, c),
      // Invalidates all Post-type queries providing the `LIST` id - after all, depending of the sort order,
      // that newly created post could show up in any lists.
      invalidatesTags: ['dns-records', 'dns-record'],
    }),

    deleteRecordByUuid: builder.mutation<void, RequestMutationWrapper<BaseModel>>({
      query: (request) => HandleQuery({
        url: `${baseurl}/dns/records/${request.data.uuid}`,
        method: 'DELETE',
        responseHandler: (res) => handleResponse({ response: res, toastSuccessText: "Record was deleted!", toastErrorText: "Record could not be deleted" }),
      }),
      invalidatesTags: ['dns-records']
    }),

    getRecordById: builder.query<DnsCreateTXTResponse, string>({
      query: (uuid) => HandleQuery({
        url: `${baseurl}/dns/records/${uuid}`,
        responseHandler: (res) => handleResponse({ response: res, toastWithResult: false, toastErrorText: "Record could no be fetched" }),
      }),
      transformResponse: (a: DnsCreateTXTResponse, b, c) => transformSingleResponseToRightType(DnsCreateTXTResponse, a, b, c),
      providesTags: ['dns-record']
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAllRecordsByOrgIdQuery, useGetAllRecordsQuery, useGetRecordByIdQuery, useDeleteRecordByUuidMutation, useAddRecordMutation } = dnsApiSlice
